import moment from 'moment';
import * as React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TableWidgetComponentFactory } from '~/components/MyWorkspace/TableWidget';
import { TabModules, useModulesConfig } from '~/data/company';
import { RewardingTabs } from '~/data/tabs';
import { People } from '~/services/Http';
import { useGetTeamTimesheet } from '~/services/Http/hooks';

import { WidgetProps, getWidgetDataRequestRoles } from '../../data/widgets';

import { TableHeader } from './components/TableHeader';
import { TeamMemberExtraHoursBalance } from './components/TeamMemberExtraHoursBalance';

const TeamTimeManagementWidgetComponent = TableWidgetComponentFactory({
  TableRowComponent: TeamMemberExtraHoursBalance,
  getIdentifier: (item: People.TimesheetShortDto) => item.id,
  TableHeaderComponent: TableHeader,
  dataCy: 'team-time-management-widget',
});

export interface Props extends WidgetProps {}

export const TeamTimeManagementWidget: React.FC<Props> = ({
  title,
  config,
}) => {
  const { t } = useTranslation();

  const dataRequestRoles = useMemo(() => {
    return getWidgetDataRequestRoles(config?.role);
  }, [config]);

  const getTeamTimesheetReqParams = {
    employeeId: 'me',
    roles: dataRequestRoles,
  };
  const {
    data: timesheet,
    loading,
    failedToLoad,
  } = useGetTeamTimesheet(getTeamTimesheetReqParams);

  const { isModuleTabEnabled } = useModulesConfig();
  const sortedTimesheetArray = (timesheet: People.TimesheetShortDto[]) =>
    timesheet?.sort((a, b) => {
      const aAsDate = new Date(
        moment.duration(a.extraHoursBalance).asMilliseconds(),
      );
      const bAsDate = new Date(
        moment.duration(b.extraHoursBalance).asMilliseconds(),
      );
      if (aAsDate < bAsDate) {
        return 1;
      } else if (aAsDate > bAsDate) {
        return -1;
      }

      return 0;
    });

  return (
    <TeamTimeManagementWidgetComponent
      title={title || t('teamTimeManagement')}
      data={timesheet && sortedTimesheetArray(timesheet)}
      loading={loading}
      failedToLoad={failedToLoad}
      noDataMessage={t('noExtraHoursBalanceInfo')}
      isTabDisabled={
        !isModuleTabEnabled(TabModules.REWARDING, RewardingTabs.WorkTime)
      }
    />
  );
};
